const utils = require('frontend-controller/lib/utils')
const downloader = require('frontend-controller/client/downloader')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'table',
        'table',
    ],

    config: {
        buttonContext: 'employeeReports',
        showHead: true,
        showIDs: true,
        showTDVerticalTop: true,
        isSortable: true,
        preventSortOfField: {},
        rowActionsInline: true,
        rowActionsProperties: {
            colWidth: '75px',
        },
        rowActions: {
            edit: true,
            customs: [
                {
                    buttonType: 'showExport',
                    neutral: true,
                },
            ]
        },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_employeeReports': true,
        },
    },

    model: {
        resourceFilters: {
            order: [{
                fieldCode: 'startTS',
                direction: 'desc'
            },{
                fieldCode: 'employee',
                direction: 'asc'
            }]
        }
    },

    events: {
        hoverIn: {
            type: 'mouseenter',
            selector: 'tbody',
            action: function(event){
                const self = event.data.component
                const $target = $(event.target).closest('tbody')
                const rowID = $target.data('rowId')
                if(rowID){
                    const employeeReportData = self.getRowData(rowID)
                    if(employeeReportData && self.model.controller){
                        self.model.controller.triggerFind('update', {
                            employeeReportData
                        }, 'templates_office_employeeReports_charts_hourDetailsDoughnut')
                    }
                }
            }
        }
    },

    methods: {
        onPrepareDone(){
            this.config.customHeadActionsFormMapping = {
                buttons: [
                    { buttonType: 'showExport', context: this.config.buttonContext }
                ]
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            switch(((callerComponent || {}).config || {}).entityContext){
                case 'employeeReports':
                    this.refreshData(true)
                    break;
            }
        },

        async showExport(rowID, rowData){
            const attributes = (rowData || {}).attributes || {}

            if(attributes.employeeID && attributes.startTS){
                this.startExport(
                    {
                        monthStartTS: attributes.startTS,
                        employeeID: attributes.employeeID
                    },
                    `${String(attributes.employeeNickname || attributes.employeeName || 'UNKNOWN_EMPLOYEE').replaceAll(/\s+/g, '_')}_${utils.moment(attributes.startTS).format('MMMM-YYYY')}.xlsx`
                )
            } else {
                await this.startMassExport()
            }
        },

        async startMassExport(){
            try {
                const resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {}
                const filters 	= resourceFilters.filters || {}

                const actionContext = await this.performAction(
                    this.prepareAction('get_employees_forEmployeeReportExport', undefined, undefined, {
                        source: {
                            load: {
                                resourceFilters: filters,
                            }
                        }
                    })
                )
                const data = (((actionContext || {}).action || {}).response || {}).data || []
                const nrOfEntries = utils.collectionSize(data)

                if(nrOfEntries < 1){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'error:employeeReports.export.employeeReports.noAvailableEmployeesFound'
                        }
                    })
                }

                if(!filters.monthStartTS && !filters.employeeID && nrOfEntries > 100){
                    const decisionContext = await this.performDecision(
                        'confirm',
                        {
                            component:      this,
                            title:          storage.__('employeeReports.export.exportAllHint.title'),
                            message:        storage.__('employeeReports.export.exportAllHint.message', { nrOfEntries }),
                            showLineFeeds: true,
                        }
                    ) || {}

                    const decision = decisionContext.decision || {}
                    if(decision.type !== 'yes'){
                        return true
                    }
                }

                const downloads = []
                for(const employee of Object.values(data)){
                    const attributes = employee.attributes || {}
                    if(attributes.employeeID && attributes.startTS){
                        downloads.push(this.startExport(
                            {
                                monthStartTS: attributes.startTS,
                                employeeID: attributes.employeeID
                            },
                            `${String(attributes.employeeNickname || attributes.employeeName || 'UNKNOWN_EMPLOYEE').replaceAll(/\s+/g, '_')}_${utils.moment(attributes.startTS).format('MMMM-YYYY')}.xlsx`,
                            false
                        ))
                    }
                }

                const result = await utils.promise.resolveAll(this, downloads)

                if(result.isRejected){
                    await this.performMessage({
                        messageDisplay: {
                            message: 'error:employeeReports.export.employeeReports.multiFileDownloadError',
                            variables: {
                                nrOfEntries:    result.nrOfPromises,
                                nrOfErrors:     result.nrOfRejections,
                                nrOfSuccesses:  result.nrOfResolves,
                            }
                        }
                    })
                }

            } catch (error){
                console.error(error)
            }
        },

        async startExport(additionalFilters, filename, handleError = true){
            const resourceFilters 	= utils.copy(this.getResourceFilters(storage, undefined, 'refreshResources')) || {}
            resourceFilters.filters = {
                ...resourceFilters.filters,
                ...(additionalFilters || {}),
            }

            filename = filename || 'employeeReport_' + utils.moment().format('YYYY-MM-DD_hh-mm-ss') + '.xlsx'
            const url = `/LTR/~/exports/office/employeeReports/~/${filename}?body=${Buffer.from(JSON.stringify({
                resourceFilters: resourceFilters
            })).toString('base64')}`

            try {
                await downloader.download(url, filename)
            } catch (error) {
                if(handleError){
                    return this.performMessage({
                        messageDisplay: {
                            message: 'error:employeeReports.export.employeeReports.fileDownloadError'
                        }
                    })
                }

                // rethrow error if necessary to collect and handle them at another time. e.g., startMassExport()
                throw error
            }
        },
    },
}